function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="29" height="32" viewBox="0 0 29 32" {...props}><path d="M14 18V4C6.268 4 0 10.268 0 18s6.268 14 14 14 14-6.268 14-14a13.94 13.94 0 0 0-1.476-6.262L14 18zM28.524 7.738C26.225 3.15 21.481 0 16 0v14l12.524-6.262z" /></svg>;
});